import api, { ResponseCallback, ResponseAndErrorCallback } from '../services/api.service'
import { AddressData } from './address.api'
import { TimezoneData } from './timezone.api'

export type Status = 'email unverified' | 'email verified' | 'approved' | 'rejected' | 'expired' | 'onboarded' | 'closed'
export type SubscriptionType = 'regular' | 'customLabel' | 'productionCustomLabel'

export interface SubscriptionData {
  id: number
  timezoneId: number
  addressId: number
  type: SubscriptionType
  name: string
  role: string
  username: string
  email: string
  phone: string
  organization: string
  status: Status
  expireAt: string
  createdAt: string
  updatedAt: string
  timezone?: TimezoneData
  address?: AddressData
}

export interface SubscriptionPackage {
  id: number;
  name: string;
  price: number;
  description: string;
}

export interface SubscriptionCreateRequest {
  type?: SubscriptionType
  fullName?: string
  role?: string
  username?: string
  email?: string
  phone?: string
  organizationName?: string
  timezone?: string
  address?: string
  city?: string
  state?: string
  zip?: string
}

export interface SubscriptionVerifyEmailRequest {
  token?: string
}

export interface SubscriptionVerifyEmailResponse {
  verified: boolean
}

export interface SubscriptionApproveResponse {
  approved: boolean
}

export interface SubscriptionRejectResponse {
  rejected: boolean
}

export interface SubscriptionOnboardResponse {
  onboarded: boolean
}

export interface SubscriptionCloseResponse {
  closed: boolean
}

export interface PendingPaymentRequest {
  amount: number
  packageId: number
  email: string
  name: string
  subId: number
}

export interface UserPendingPaymentRequest {
  amount: number
  packageId: number
  id: number
}

export interface PendingPayment {
  payment_intent_id: string
  client_secret: string
  customer_id: string
  customer_secret: string
}

export interface MembershipData {
  type: string
  price: string
  name: string
  status: string
}

const routes = {
  list: '/subscriptions',
  paymentIntent: '/payment',
  create: '/subscriptions',
  userPaymentIntent: '/payment/user/',
  membership: '/membership/',
  cancel: '/membership/cancel/'
}

export default {

  list (callback: ResponseCallback<SubscriptionPackage[]>) {
    api.get(routes.list, {}, callback)
  },

  paymentIntent(payload: PendingPaymentRequest, callback: ResponseCallback<PendingPayment>){
    api.post(routes.paymentIntent, payload, callback)
  },

  userPaymentIntent(payload: UserPendingPaymentRequest, callback: ResponseCallback<PendingPayment>){
    api.post(routes.userPaymentIntent+payload.id, payload, callback)
  },

  getActiveMembership(id: number, callback: ResponseCallback<MembershipData>){
    api.get(routes.membership+id, {}, callback)
  },

  create (
    payload: SubscriptionCreateRequest,
    callback: ResponseCallback<SubscriptionData>,
    errorCallback: ResponseAndErrorCallback
  ) {
    api.postAndError(routes.create, payload, callback, errorCallback)
  },

  cancelSubscription(id: number, callback: ResponseCallback<string>){
    api.post(routes.cancel+id, {}, callback)
  }
}